import { Ref, WritableComputedRef } from "vue";
import { FormElementBase } from "~/api";

export interface DragDropState {
  isDragging: Ref<boolean, boolean>;
  handleDropComponent: (e: DragEvent, repeaterGuid?: string) => Promise<void>;
  handleClickComponent: (
    component: FormElementBase,
    event?: MouseEvent,
  ) => void;
  handleOnDrag: (e: DragEvent, component: FormElementBase) => void;
  editingComponent: WritableComputedRef<
    FormElementBase | undefined,
    FormElementBase | undefined
  >;
  canDropInRepeater: Ref<boolean, boolean>;
}

export function useDragDrop({
  isDragging,
  handleDropComponent,
  handleClickComponent,
  handleOnDrag,
  editingComponent,
  canDropInRepeater,
}: DragDropState) {
  return {
    isDragging,
    handleDropComponent,
    handleClickComponent,
    handleOnDrag,
    editingComponent,
    canDropInRepeater,
  };
}
